import {omneticApi as api} from '@dms/api/base';

import {
  GetTestDriveApiArgTestDriveNew,
  GetTestDriveApiResponseTestDriveNew,
  ListTestDriveApiArgTestDriveNew,
  ListTestDriveApiResponseTestDriveNew,
  UpdateTestDriveApiArg,
  UpdateTestDriveApiResponse,
  DeleteTestDriveApiResponse,
  DeleteTestDriveApiArg,
  CreateTestDriveDocumentApiResponse,
  CreateTestDriveDocumentApiArg,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTestDrive: build.query<GetTestDriveApiResponseTestDriveNew, GetTestDriveApiArgTestDriveNew>({
      query: (queryArg) => ({
        url: `/dms/v1/test-drive/${queryArg.id}`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'TestDrive', id: queryArg.id}],
    }),
    listTestDriveV2: build.query<
      ListTestDriveApiResponseTestDriveNew,
      ListTestDriveApiArgTestDriveNew
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/test-drive`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleTestDrives', id: queryArg.vehicleId},
      ],
    }),
    updateTestDrive: build.mutation<UpdateTestDriveApiResponse, UpdateTestDriveApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/test-drive/${queryArg.testDriveId}`,
        method: 'PUT',
        body: queryArg.updateTestDriveRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => {
        const tags: Array<
          | {type: 'TestDrive'; id: string}
          | {type: 'VehicleTestDrives'}
          | {type: 'VehicleTestDrivesV1'}
          | {type: 'BusinessCaseTestDrive'}
          | {type: 'BusinessCaseActivity'; id: string}
        > = [
          {type: 'TestDrive', id: queryArg.testDriveId},
          {type: 'VehicleTestDrives'},
          {type: 'VehicleTestDrivesV1'},
          {type: 'BusinessCaseTestDrive'},
        ];
        if (queryArg.businessCaseId) {
          tags.push({type: 'BusinessCaseActivity', id: queryArg.businessCaseId});
        }
        return tags;
      },
    }),
    deleteTestDrive: build.mutation<DeleteTestDriveApiResponse, DeleteTestDriveApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/test-drive/${queryArg.testDriveId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'TestDrive', id: queryArg.testDriveId},
        {type: 'VehicleTestDrives'},
        {type: 'VehicleTestDrivesV1'},
        {type: 'BusinessCaseTestDrive'},
        {type: 'BusinessCaseActivity', id: queryArg.businessCaseId},
      ],
    }),
    createTestDriveDocument: build.mutation<
      CreateTestDriveDocumentApiResponse,
      CreateTestDriveDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/test-drive/document`,
        method: 'POST',
        body: queryArg.createTestDriveDocumentRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'TestDrive', id: queryArg.createTestDriveDocumentRequestBody.testDriveId},
        {type: 'VehicleTestDrives'},
        {type: 'BusinessCaseTestDrive'},
        'documentsCount',
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTestDriveQuery,
  useUpdateTestDriveMutation,
  useListTestDriveV2Query,
  useDeleteTestDriveMutation,
  useCreateTestDriveDocumentMutation,
} = injectedRtkApi;
